import { array, bool, func, object } from 'prop-types';
import { Group } from '../const';
import useModal from '../hooks/useModal';
import TableList from './TableList';
import MenuModal from './MenuModal';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { ArrowBottom, ArrowRight } from 'components/icons';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import sty from '../styles/GroupRoleList.module.css';

/**
 * @component GroupRoleList
 * @param { Object } props
 * @param { boolean } props.open
 * @param { object } props.savingState
 * @param { object } props.savingHandler
 * @param { object } props.group
 * @param { array } props.roles
 * @param { array } props.tabs
 * @param { function } props.onMenu
 * @returns { JSX.Element }
 */
function GroupRoleList(props) {
	const state = useModal(props.savingState, props.savingHandler);

	return (
		<Collapse in={props.open} timeout="auto" unmountOnExit>
			<section className={sty.section}>
				<IconButton onClick={state.onToggle}>
					{state.open ? <ArrowBottom /> : <ArrowRight />}
				</IconButton>
				<InputBase value={props.group[Group.Name]} />
			</section>
			<TableList
				open={state.open}
				savingState={props.savingState}
				savingHandler={props.savingHandler}
				groupId={props.group[Group.Id]}
				selectedTabs={props.group[Group.Tabs]}
				selectedRoles={props.group[Group.Roles]}
				roles={props.roles}
				tabs={props.tabs}
				onMenu={props.onMenu}
			/>
			{state.modal && (
				<MenuModal open={state.modal} onClose={state.onClose} onSave={state.onSave} />
			)}
			<LoadingBackdrop open={props.savingState.loading} />
		</Collapse>
	);
}

GroupRoleList.propTypes = {
	open: bool,
	savingState: object,
	savingHandler: object,
	group: object,
	roles: array,
	tabs: array,
	onMenu: func,
};

export default GroupRoleList;
